import React from "react";
import PropTypes from "prop-types";
import styles from "./PermissionBubble.module.css";

const sizeClassMap = {
  sm: styles.bubbleSm,
  lg: styles.bubbleLg,
};

const toneClassMap = {
  neutral: styles.toneNeutral,
  light: styles.toneLight,
  emerald: styles.toneEmerald,
  teal: styles.toneTeal,
  gray: styles.toneGray,
  platinum: styles.tonePlatinum,
  emeraldDark: styles.toneEmeraldDark,
};

export function PermissionBubble({
  label,
  active,
  onClick,
  size,
  tone,
  iconSrc,
  iconAlt,
}) {
  const [iconLoadFailed, setIconLoadFailed] = React.useState(false);
  const showIcon = !!iconSrc && !iconLoadFailed;

  React.useEffect(() => {
    setIconLoadFailed(false);
  }, [iconSrc]);

  return (
    <button
      type="button"
      className={`${styles.bubble} ${sizeClassMap[size]} ${
        toneClassMap[tone]
      } ${active ? styles.bubbleActive : ""}`}
      onClick={onClick}
      aria-pressed={active}
    >
      {showIcon ? (
        <img
          src={iconSrc}
          alt={iconAlt || label}
          className={styles.icon}
          draggable={false}
          onError={() => setIconLoadFailed(true)}
        />
      ) : (
        label
      )}
    </button>
  );
}

PermissionBubble.propTypes = {
  label: PropTypes.string.isRequired,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(["sm", "lg"]),
  tone: PropTypes.oneOf([
    "neutral",
    "light",
    "emerald",
    "teal",
    "gray",
    "platinum",
    "emeraldDark",
  ]),
  iconSrc: PropTypes.string,
  iconAlt: PropTypes.string,
};

PermissionBubble.defaultProps = {
  active: false,
  onClick: undefined,
  size: "sm",
  tone: "teal",
  iconSrc: "",
  iconAlt: "",
};
